import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, withStyles } from '@material-ui/core';
import { STATIC_PATH } from 'constants';

const StyledSwitch = withStyles((theme) => {
  return {
    root: {
      width: theme.spacing(7.5),
      height: theme.spacing(5),
      padding: theme.spacing(1),
      margin: 0,
      overflow: 'hidden',
    },
    switchBase: {
      padding: theme.spacing(1),
      top: theme.spacing(0.5),
      left: theme.spacing(0.5),
      color: theme.palette.greyBlue[600],
      '&$checked': {
        transform: 'translateX(20px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: `${theme.palette.shelfBlue[500]}`,
          opacity: 1,
          borderColor: `${theme.palette.shelfBlue[500]}`,
        },
        '& + $track::after': {
          content: `url(${STATIC_PATH}/images/switch-checkmark.svg)`,
          display: 'inline-block',
          padding: `${theme.spacing(0.4, 0, 0, 0.5)}`,
        },
      },
      '&:not($checked)': {
        '& + $track': {
          backgroundColor: 'rgba(255, 255, 255, 0.2) !important',
        },
      },
      '&.Mui-checked:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
      },
    },
    thumb: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      boxShadow: 'none',
    },
    track: {
      borderRadius: theme.spacing(2),
      border: `1px solid ${theme.palette.greyBlue[600]}`,
      backgroundColor: `${theme.palette.common.white}`,
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
      color: `${theme.palette.common.white}`,
    },
    checked: {},
  };
})(Switch);

const CheckmarkSwitch = ({ isEnabled, onToggle, inputProps, ...props }) => {
  const [isChecked, setIsChecked] = useState(isEnabled);

  const handleOnChange = useCallback(() => {
    setIsChecked(!isChecked);
    onToggle(!isChecked);
  }, [isChecked, onToggle]);

  return (
    <StyledSwitch
      checked={isChecked}
      onChange={handleOnChange}
      inputProps={{
        role: 'switch',
        'aria-checked': isChecked,
        ...inputProps,
      }}
      {...props}
    />
  );
};

CheckmarkSwitch.propTypes = {
  isEnabled: PropTypes.bool,
  onToggle: PropTypes.func,
  inputProps: PropTypes.object,
};

CheckmarkSwitch.defaultProps = {
  isEnabled: false,
  onToggle: () => {},
  inputProps: {},
};

export default CheckmarkSwitch;
